
export const REQUEST_EDITBUTTONNAME= 'REQUEST_EDITBUTTONNAME';
export const EDITBUTTONNAME_RECEIVED = 'EDITBUTTONNAME_RECEIVED';